import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Header from './Header';
import { apiBaseURL, apiURL, apiKey, ckFinderURL } from '../../constant';
import Swal from "sweetalert2";

const AddTopic = () => {
    const navigate = useNavigate();
    const [subjects, setSubjects] = useState([]);
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sectionIDs, setSectionIDs] = useState([]);
    const [showTopicForm, setShowTopicForm] = useState(false);
    const [editTopicID, setEditTopicID] = useState(null);

    const [formData, setFormData] = useState({
        questionCatDesc: '',
        subjectIDs: [],
        sectionIDs: '',
        totalMarks: '',
        totalQuestion: '',
        markPerQuestion: '',
        negativeMark: '',
        createdDate: '',
    });
    const [editFormData, setEditFormData] = useState({
        questionCatDesc: '',
        subjectIDs: '',
        sectionIDs: '',
        totalMarks: '',
        totalQuestion: '',
        markPerQuestion: '',
        negativeMark: ''
    });

    useEffect(() => {
        fetchSubjects();
        fetchTopics();
    }, []);
    const fetchSubjects = async () => {
        try {
            const response = await fetch(apiBaseURL + apiURL.getSubjects, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                }
            });
            const result = await response.json();
            if (result.status === 1) {
                setSubjects(result.data);
            } else {
                setSubjects([]);
            }
        } catch (error) {
            console.error("Error fetching subjects:", error);
            setSubjects([]);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const { questionCatDesc, subjectIDs, totalMarks, totalQuestion, markPerQuestion, negativeMark } = formData;

        const data = {
            questionCatDesc, subjectIDs: formData.subjectIDs, sectionIDs: sectionIDs.join(','), totalMarks, totalQuestion, markPerQuestion, negativeMark
        };
        console.log("API Data:", data);
        try {
            const url = apiBaseURL + apiURL.saveTopic;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                },
                body: JSON.stringify(data)
            });
            const result = await response.json();
            console.log("API Response:", result);
            if (result.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: result.message,
                    confirmButtonText: "OK",
                });
                handleReset();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops! ",
                    text: result.message,
                    confirmButtonText: "OK",
                });
            }

        }
        catch (error) {
            console.error("API Error:", error);
            Swal.fire({
                icon: "error",
                title: "Something went wrong!",
                text: "Please try again. To add new topic.",
                confirmButtonText: "OK",
            });
        }
    };

    const handleReset = () => {
        setFormData({
            questionCatDesc: '',
            subjectIDs: '',
            totalMarks: '',
            totalQuestion: '',
            markPerQuestion: '',
            negativeMark: '',
        });
        setSectionIDs([]);
    };
    const fetchTopics = async () => {
        try {
            const response = await fetch(apiBaseURL + apiURL.showTopics, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                }
            });
            const result = await response.json();
            if (result.status === 1) {
                setTopics(result.data);
                console.log(result);
            } else {
                setTopics([]);
            }
        } catch (error) {
            console.error("Error fetching topics:", error);
            setTopics([]);
        } finally {
            setLoading(false);
        }

    };
    // -----------------------Handle Edit-----------------------------------------//
    const handleEdit = (topic) => {
        setEditTopicID(topic.questionCatID);
        setEditFormData({
            questionCatDesc: topic.questionCatDesc || '',
            totalMarks: topic.totalMarks || '',
            totalQuestion: topic.totalQuestion || '',
            markPerQuestion: topic.markPerQuestion || '',
            negativeMark: topic.negativeMark || ''
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;

        setEditFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCancelEdit = () => {
        setEditTopicID(null);
        setEditFormData({
            questionCatDesc: '',
            totalMarks: '',
            totalQuestion: '',
            markPerQuestion: '',
            negativeMark: ''
        });
    };

    const handleUpdate = async (questionCatID) => {
        try {
            const response = await fetch(apiBaseURL + apiURL.updateTopic, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                },
                body: JSON.stringify({
                    questionCatID: questionCatID,
                    questionCatDesc: editFormData.questionCatDesc,
                    totalMarks: editFormData.totalMarks,
                    totalQuestion: editFormData.totalQuestion,
                    markPerQuestion: editFormData.markPerQuestion,
                    negativeMark: editFormData.negativeMark
                })
            }
            );
            const data = await response.json();
            if (data.status) {
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: data.message,
                    confirmButtonText: "OK",
                });
                setTopics(prev =>
                    prev.map(topic =>
                        topic.questionCatID === questionCatID
                            ? { ...topic, ...editFormData } : topic
                    )
                );
                setEditTopicID(null);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Something went wrong!",
                    text: data.message || "Please try again. To add new topic.",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Something went wrong!",
                text: error.message || "Please try again. To add new topic.",
                confirmButtonText: "OK",
            });
        }
    };
    // ---------------------------------------End----------------------------------------------------//
    // ----------------------------------HandleDelete--------------------------------------//
    const handleDelete = async (questionCatID) => {
        const result = await Swal.fire({
            title: "Warning?",
            text: "You want to delete this topic?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });
        if (!result.isConfirmed) {
            return;
        }
        try {
            const url = apiBaseURL + apiURL.deleteTopic;
            console.log("Delete URL:", url);
            console.log("Topic ID:", questionCatID);
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                },
                body: JSON.stringify({
                    questionCatID: questionCatID
                })
            });
            const data = await response.json();
            if (data.status) {
                setTopics(prevTopics =>
                    prevTopics.filter(topic => topic.questionCatID !== questionCatID)
                );
                Swal.fire({
                    icon: "success",
                    title: "Deleted!",
                    text: data.message,
                    confirmButtonText: "OK",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Delete failed!",
                    text: data.message,
                    confirmButtonText: "OK",
                });
            }

        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Something went wrong!",
                text: error.message,
                confirmButtonText: "OK",
            });
        }
    };
    // ----------------------------------End---------------------------------------------------//
    return (
        <>
            <Header />
            <div className="container-fluid px-3 px-md-4 py-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '12px' }}>
                    <div><h4 className="mb-1">Add Topic</h4><small className="text-muted">Add a new topic for the following subject</small></div>
                    <button type="button" className="btn btn-outline-secondary mt-2 mt-md-0" onClick={() => navigate(-1)}><ArrowBackIcon style={{ fontSize: '18px', marginRight: '5px' }} />Back</button>

                </div>
                <div className="card shadow-sm">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-10 mb-3">

                            </div>
                            <div className="col-md-2 mb-3">
                                <button type="button" className="btn btn-success btn-sm pull-right" onClick={() => setShowTopicForm(prev => !prev)}><i className='fa fa-plus' style={{ fontSize: '18px', marginRight: '5px' }} > </i> Add New Topic
                                </button>
                                <button type="button" className="btn btn-warning btn-sm" onClick={() => window.location.reload()} >
                                    <i className="fa fa-refresh" style={{ fontSize: '16px', marginRight: '5px' }}></i> Reload Data
                                </button>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit} style={{ display: showTopicForm ? 'block' : 'none' }} id='addTopicForm'>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label className="form-label d-block">Select Sections</label>
                                    <div className="row" style={{ "border": "1px solid #ccc", "padding": "5px" }}>
                                        <div className="col-md-4 mb-3">
                                            <div className="form-check form-check-inline" >
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="section1"
                                                    value="1"
                                                    checked={sectionIDs.includes("1")}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setSectionIDs(prev => [...prev, "1"]);
                                                        } else {
                                                            setSectionIDs(prev => prev.filter(id => id !== "1"));
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label" for="section1">
                                                    English
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="section2"
                                                    value="2"
                                                    checked={sectionIDs.includes("2")}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setSectionIDs(prev => [...prev, "2"]);
                                                        } else {
                                                            setSectionIDs(prev => prev.filter(id => id !== "2"));
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label" for="section2">
                                                    Domain Specific Subjects
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="section3"
                                                    value="3"
                                                    checked={sectionIDs.includes("3")}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setSectionIDs(prev => [...prev, "3"]);
                                                        } else {
                                                            setSectionIDs(prev => prev.filter(id => id !== "3"));
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label" for="section3">
                                                    General Aptitude Test
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    {sectionIDs.includes("2") && (
                                        <div className="row">
                                            {subjects.length > 0 &&
                                                subjects.map((subject) => (
                                                    <div className="col-md-4 mb-2" key={subject.subjectID}>
                                                        <div className="form-check">
                                                            <input name='subjectIDs' className="form-check-input" type="checkbox" id={`subject_${subject.subjectID}`} value={subject.subjectID} checked={formData.subjectIDs.includes(String(subject.subjectID))} onChange={(e) => { const value = e.target.value; setFormData((prev) => ({ ...prev, subjectIDs: e.target.checked ? [...prev.subjectIDs, value] : prev.subjectIDs.filter((id) => id !== value) })); }} />
                                                            <label className="form-check-label" htmlFor={`subject_${subject.subjectID}`} > {subject.subjectName}</label>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Topic Name <span className="text-danger">*</span></label>
                                    <input type="text" name="questionCatDesc" className="form-control" value={formData.questionCatDesc} onChange={handleChange} required />
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label className="form-label">Total Marks <span className="text-danger">*</span>  <small style={{ "color": "#ccc" }}>(Ex. 5, 10, 20 etc.)</small></label>
                                    <input type="text" name="totalMarks" className="form-control" value={formData.totalMarks} onChange={handleChange} required />
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label className="form-label">Total Questions <span className="text-danger">*</span>  <small style={{ "color": "#ccc" }}>(Ex. 5, 10, 20 etc.)</small></label>
                                    <input type="text" name="totalQuestion" className="form-control" value={formData.totalQuestion} onChange={handleChange} required />
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label className="form-label">Marks Per Question <span className="text-danger">*</span>  <small style={{ "color": "#ccc" }}>(Ex. 1.5, 2.5 etc.)</small></label>
                                    <input type="text" name="markPerQuestion" className="form-control" value={formData.markPerQuestion} onChange={handleChange} required />
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label className="form-label">Negative Marks <span className="text-danger">*</span> <small style={{ "color": "#ccc" }}>(Ex. 0.5, 1 etc.)</small></label>
                                    <input type="text" name="negativeMark" className="form-control" value={formData.negativeMark} onChange={handleChange} required />
                                </div>
                            </div>

                            <div className="d-flex flex-wrap gap-2 mt-3" style={{ borderTop: '1px solid #dee2e6', paddingTop: '15px' }}>
                                <button type="submit" className="btn btn-primary"><SaveIcon style={{ fontSize: '18px', marginRight: '5px' }} />Save</button>
                                <button type="reset" className="btn btn-outline-secondary" onClick={handleReset}><RestartAltIcon style={{ fontSize: '18px', marginRight: '5px' }} />Reset</button>
                                <button type="button" className="btn btn-outline-danger" onClick={() => navigate(-1)}>Cancel</button>
                            </div>
                        </form>

                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className='chapterData' style={{ "font-size": "15px", "height": "40vh", "overflow-y": "scroll" }}>
                                    <table className="table table-bordered table-striped" style={{ "font-size": "15px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>S.N</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Topic Name</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Subjects</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Sections</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Total Marks</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Total Questions</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Marks/Que</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Negative Marks</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Created On</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }} className='text-center'>Action</th>
                                            </tr>
                                        </thead>

                                        {/* <tbody>
                                            {topics.length > 0 ? (topics.map((topic, index) => (
                                                <tr key={topic.questionCatID}>
                                                    <td>{index + 1}</td>
                                                    <td>{topic.questionCatDesc}</td>
                                                    <td>{topic.subjectIDs}</td>
                                                    <td>{topic.sectionIDs}</td>
                                                    <td>{topic.totalMarks}</td>
                                                    <td>{topic.totalQuestion}</td>
                                                    <td>{topic.markPerQuestion}</td>
                                                    <td>{topic.negativeMark}</td>
                                                    <td>{topic.createdDate
                                                        ? new Date(topic.createdDate).toLocaleString('en-IN', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'
                                                    }</td>
                                                    <td className='text-center'>
                                                        <button className="btn btn-sm btn-primary me-2">
                                                            <i className="fa fa-edit"></i>
                                                        </button>
                                                        <button className="btn btn-sm btn-danger">
                                                            <i className="fa fa-close"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="10" className="text-center">
                                                        {loading ? "Loading..." : "No chapters found."}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody> */}
                                        <tbody>
                                            {topics.length > 0 ? (
                                                topics.map((topic, index) => (

                                                    <tr key={topic.questionCatID}>

                                                        <td>{index + 1}</td>

                                                        {/* Topic Name */}
                                                        <td>
                                                            {editTopicID === topic.questionCatID ? (
                                                                <input
                                                                    type="text"
                                                                    name="questionCatDesc"
                                                                    className="form-control form-control-sm"
                                                                    value={editFormData.questionCatDesc}
                                                                    onChange={handleEditChange}
                                                                />
                                                            ) : (
                                                                topic.questionCatDesc
                                                            )}
                                                        </td>

                                                        {/* Subjects */}
                                                        <td>{topic.subjectIDs}</td>

                                                        {/* Sections */}
                                                        <td>{topic.sectionIDs}</td>

                                                        {/* Total Marks */}
                                                        <td>
                                                            {editTopicID === topic.questionCatID ? (
                                                                <input
                                                                    type="number"
                                                                    name="totalMarks"
                                                                    className="form-control form-control-sm"
                                                                    value={editFormData.totalMarks}
                                                                    onChange={handleEditChange}
                                                                />
                                                            ) : (
                                                                topic.totalMarks
                                                            )}
                                                        </td>

                                                        {/* Total Questions */}
                                                        <td>
                                                            {editTopicID === topic.questionCatID ? (
                                                                <input
                                                                    type="number"
                                                                    name="totalQuestion"
                                                                    className="form-control form-control-sm"
                                                                    value={editFormData.totalQuestion}
                                                                    onChange={handleEditChange}
                                                                />
                                                            ) : (
                                                                topic.totalQuestion
                                                            )}
                                                        </td>

                                                        {/* Marks / Question */}
                                                        <td>
                                                            {editTopicID === topic.questionCatID ? (
                                                                <input
                                                                    type="number"
                                                                    step="any"
                                                                    name="markPerQuestion"
                                                                    className="form-control form-control-sm"
                                                                    value={editFormData.markPerQuestion}
                                                                    onChange={handleEditChange}
                                                                />
                                                            ) : (
                                                                topic.markPerQuestion
                                                            )}
                                                        </td>

                                                        {/* Negative Marks */}
                                                        <td>
                                                            {editTopicID === topic.questionCatID ? (
                                                                <input
                                                                    type="number"
                                                                    step="any"
                                                                    name="negativeMark"
                                                                    className="form-control form-control-sm"
                                                                    value={editFormData.negativeMark}
                                                                    onChange={handleEditChange}
                                                                />
                                                            ) : (
                                                                topic.negativeMark
                                                            )}
                                                        </td>

                                                        {/* Created Date */}
                                                        <td>
                                                            {topic.createdDate
                                                                ? new Date(topic.createdDate).toLocaleString('en-IN', {
                                                                    day: '2-digit',
                                                                    month: '2-digit',
                                                                    year: 'numeric',
                                                                    hour: '2-digit',
                                                                    minute: '2-digit',
                                                                    hour12: true
                                                                })
                                                                : '-'
                                                            }
                                                        </td>

                                                        {/* Action */}
                                                        <td className="text-center">
                                                            {editTopicID === topic.questionCatID ? (
                                                                <>
                                                                    <button type="button" className="btn btn-sm btn-success me-2" onClick={() => handleUpdate(topic.questionCatID)}><i className="fa fa-save"></i> Save
                                                                    </button>
                                                                    <button type="button" className="btn btn-sm btn-danger" onClick={handleCancelEdit}><i className="fa fa-close"></i> Cancel
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(topic)}><i className="fa fa-edit"></i>
                                                                    </button>
                                                                    <button type="button" className="btn btn-sm btn-danger" onClick={() => handleDelete(topic.questionCatID)}><i className="fa fa-close"></i></button>
                                                                </>

                                                            )}

                                                        </td>

                                                    </tr>
                                                ))

                                            ) : (
                                                <tr>
                                                    <td colSpan="10" className="text-center">
                                                        {loading ? "Loading..." : "No topics found."}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default AddTopic;
